var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speakerIcon",on:{"click":_vm.speak}},[_c('v-btn',{attrs:{"fab":"","small":"","absolute":"","color":_vm.iconColor}},[_c('v-icon',{staticClass:"buttonIcon",attrs:{"color":"white"}},[_vm._v("volume_up")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }